import { ImportType } from "src/app/enums/ImportType";
import { IEntityDto } from "./base";

export interface IDataImport extends IEntityDto {
  description?: string;
  isFinished?: boolean;
  finished?: Date;
  auditFileCountry?: string;
  auditFileCreated?: Date;
  softwareCompany?: string;
  softwareId?: string;
  fiscalRegistrationNumber?: number;
  fiscalName?: string;
  defaultCurrencyCode?: string;
  importType?: ImportType;
}
